import {DraftGuessModelV1} from '@albert-io/models';
import makeConstants from 'lib/makeConstants';
import type {UseBoundStore, StoreApi} from 'zustand';
import {Draft} from 'immer';

// See: 'client/components/QuestionTypes/QuestionType.types.ts' for status Order
// camelCase versions of save statuses used here

export const allSaveStatuses = [
  'default',
  'loading',
  'loadError',
  'saved',
  'savedError',
  'saving'
] as const;

export const saveStatus = makeConstants(...allSaveStatuses);

export type SaveStatus = (typeof allSaveStatuses)[number];

export interface DraftInfo {
  draft: DraftGuessModelV1 | null;
  saveStatus: SaveStatus;
  editStartTime: Date | null;
}

export interface DraftGuessState {
  assignmentId: string | null;
  // storing draft guesses by question id
  draftByQuestionId: Record<string, DraftInfo>;
  draftGuessPromise: null | any;

  // going to access guess properties from instance directly instead of
  // storing guess values in the store itself

  // removed legacy store values
  // draftId
  // lastDraftTime
  // timeElapsed
  // pointsEarned
  // isGuessCorrect
}

export interface DraftGuessActions {
  // legacy draft actions
  hasDraftGuess: (questionId: string) => boolean;
  buildTimeElapsed: (questionId: string) => any; // time
  loadDraftGuess: (assignmentId: string | null, questionId: string) => DraftGuessModelV1;
  saveDraftGuess: (assignmentId: string | null, questionId: string, draftContent: any) => void;
  shouldNotSaveDraft: () => boolean;
  startTimer: (questionId: string) => void;
}

export const initialState: DraftGuessState = {
  assignmentId: null,
  draftByQuestionId: {}, // todo changes this to also store save statuses, edit start time draft guess promise maybe
  draftGuessPromise: null
};

export type DraftGuessStore = DraftGuessState & DraftGuessActions;

export type SetState = SetStateWithImmer<DraftGuessStore>;
export type GetState = UseBoundStore<StoreApi<DraftGuessStore>>['getState'];

// Allows set State to be used with immer
export type SetStateWithImmer<T> = (
  nextState: T | Partial<T> | ((state: Draft<T>) => void),
  replace?: boolean
) => void;
